import type { PersistStorage, StorageValue } from 'zustand/middleware'

import { getUserId } from './authUser.store'

export const createUserStorage = <T>(
  storage: Storage = localStorage,
): PersistStorage<T> => ({
  getItem: (name: string): StorageValue<T> | null => {
    const userId = getUserId()

    if (!userId) {
      return null
    }

    const key = `${userId}:${name}`
    const value = storage.getItem(key)

    try {
      return value ? JSON.parse(value) : null
    } catch {
      return null
    }
  },
  setItem: (name: string, value: StorageValue<T>): void => {
    const userId = getUserId()

    if (!userId) {
      return
    }

    const key = `${userId}:${name}`

    storage.setItem(key, JSON.stringify(value))
  },
  removeItem: (name: string): void => {
    const userId = getUserId()

    if (!userId) {
      return
    }

    const key = `${userId}:${name}`

    storage.removeItem(key)
  },
})
